import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface IFeaturesInfoBulle {
    handleClose: () => void
}

const FeaturesInfoBulle = (props: IFeaturesInfoBulle) => {
  return (
    <div className="p-4">
      {/* Close Icon */}
      <FontAwesomeIcon
        icon={faTimes} // Close icon
        className="position-absolute top-0 end-0 m-2 cursor-pointer"
        onClick={props.handleClose} // Close the popover
        aria-label="Close"
      />
      <h5 className="mb-3">Fonctionnalité d'envoi d'e-mails</h5>
      <ul className="ps-3 mb-3 listFeaturesInfoBulle">
        <li className="mb-2">
          Vous pouvez envoyer gratuitement jusqu'à 1000 e-mails par mois à votre
          clientèle depuis cet espace.
        </li>
        <li className="mb-2">
          Il est obligatoire de valider l'adresse e-mail ajoutée pour pouvoir
          effectuer un envoi.
        </li>
        <li className="mb-2">
          Vous pouvez inclure dans vos e-mails : texte, pièces jointes, image de
          couverture, et votre logo.
        </li>
        <li className="mb-2">
          Les images de couverture peuvent être créées sur des outils comme
          Canva, puis importées ici.
        </li>
        <li className="mb-2">
          Vous pouvez personnaliser entièrement votre design pour promouvoir
          votre entreprise à moindre coût.
        </li>
        <li className="mb-2">
          Il est fortement recommandé d'effectuer un envoi test à votre propre
          adresse avant toute campagne.
        </li>
        <li className="mb-2">
          L'espace "Gestion des logos" vous permet d'importer un visuel de
          marque pour un affichage optimal.
        </li>
      </ul>
      <hr className="my-3" />
      <h5 className="mb-2">Limites & Tarification</h5>
      <ul className="ps-3 mb-2">
        <li className="mb-2">
          Le nombre de mails gratuits est défini par l'administrateur (ex : 500,
          1000…).
        </li>
        <li className="mb-2">
          Au-delà de la limite gratuite, une grille tarifaire s'applique :
        </li>
      </ul>
      <div className="ms-4 mb-2">
        <p className="mb-1">0 à 2 500 envois : X €</p>
        <p className="mb-1">2 501 à 10 000 envois : Y €</p>
        <p className="mb-1">Plafond fixé à 10 000 e-mails/mois.</p>
      </div>
      <p className="mb-0">
        La grille complète est consultable dans l'espace dédié.
      </p>
    </div>
  );
};

export default FeaturesInfoBulle